import { render } from "./AcademicPerformanceGrades.vue?vue&type=template&id=849804a4&ts=true"
import script from "./AcademicPerformanceGrades.vue?vue&type=script&lang=ts"
export * from "./AcademicPerformanceGrades.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__